import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Box, Typography } from '@mui/material';

export default function PdfPreview({ urlFile }) {
  const fileName = (urlFile || '').split('/').pop() || 'documento.pdf';

  const handleClick = () => {
    window.open(urlFile, '_blank', 'noopener');
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid',
        borderColor: 'grey.300',
        borderRadius: 1,
        p: 1,
        width: 200,
        cursor: 'pointer',
        bgcolor: 'background.default',
        '&:hover': { backgroundColor: 'grey.100' },
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: 120,
          borderRadius: 1,
          overflow: 'hidden',
          border: '1px solid',
          borderColor: 'grey.200',
          bgcolor: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <object data={urlFile} type="application/pdf" width="100%" height="100%">
          <PictureAsPdfIcon sx={{ fontSize: 48, color: 'error.main' }} />
        </object>
      </Box>
      <Typography variant="body2" mt={1} noWrap>
        {fileName}
      </Typography>
    </Box>
  );
}
